import { WidgetInstance } from 'friendly-challenge'

/**
 * Widget callback function for login button toggling.
 */
const loginWidgetCallback = () => {
  document.getElementById('login-submit-btn')?.removeAttribute('disabled')
}

const productConsultationMessageFormWidgetCallback = () => {
  document
    .getElementById('callback-form-message-submit-btn')
    ?.removeAttribute('disabled')
}

const productConsultationCallbackFormWidgetCallback = () => {
  document
    .getElementById('callback-form-callback-submit-btn')
    ?.removeAttribute('disabled')
}

const createFCWidget = (
  startMode: 'auto' | 'focus' | 'none' = 'focus',
  selector: string,
  doneCallBack: () => void,
  errorCallBack: () => void
) => {
  const container = document.querySelector<HTMLElement>(selector)
  const puzzleUrl = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle'

  if (!container) {
    return
  }

  new WidgetInstance(container, {
    startMode,
    puzzleEndpoint: puzzleUrl,
    doneCallback: doneCallBack,
    errorCallback: errorCallBack,
  })
}

const createFCWidgetForLogin = () => {
  createFCWidget(
    'auto',
    '#loginForm-frc-captcha',
    loginWidgetCallback,
    loginWidgetCallback
  )
}

const createFCWidgetForProductConsultationMessageForm = () => {
  createFCWidget(
    'auto',
    '#productConsultationMessageForm-frc-captcha',
    productConsultationMessageFormWidgetCallback,
    productConsultationMessageFormWidgetCallback
  )
}

const createFCWidgetForProductConsultationCallbackForm = () => {
  createFCWidget(
    'auto',
    '#productConsultationCallbackForm-frc-captcha',
    productConsultationCallbackFormWidgetCallback,
    productConsultationCallbackFormWidgetCallback
  )
}

export {
  createFCWidgetForLogin,
  createFCWidgetForProductConsultationMessageForm,
  createFCWidgetForProductConsultationCallbackForm,
}
